var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 543,
    height: 274,
    viewBox: "0 0 543 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1 -233.549L33.9591 -146.741C84.9349 -12.4804 212.092 71.5314 348.501 61.074L382.192 58.4912C468.074 51.9073 551.214 92.0398 602.797 164.979C691.933 291.021 864.203 308.71 974.589 203.156L993 185.55",
    stroke: "#F8F3A2",
    strokeWidth: 2,
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRight);
export default __webpack_public_path__ + "static/media/top-right.a386b4a992ccea2dab4b74a0eaafc9f2.svg";
export { ForwardRef as ReactComponent };